<p class="text-[#21252A] text-[20px] font-medium !ml-[6px]">Comments</p>

<div class="border p-4 bg-gray-50 mx-[8px]">
  <div class="pt-0 pb-4 space-y-4">
    <div
      *ngFor="let comment of comments"
      class="bg-white border p-4 shadow-sm space-y-2"
    >
      <div class="flex justify-between items-center">
        <div class="flex items-center gap-2">
          <img
            alt="icon"
            src="https://i.pravatar.cc/40?img={{ comment?.id }}"
            class="w-8 h-8 rounded-full"
          />
          <div>
            <p class="font-semibold">
              {{
                comment?.created_by?.username
                  ? comment?.created_by?.username
                  : (comment?.created_by?.name | titlecase)
              }}
            </p>
          </div>
        </div>
        <p class="text-xs text-gray-500">
          {{ getTimeAgo(comment?.created_at) }}
        </p>
      </div>

      <div *ngIf="!comment?.isEditing" class="text-gray-800">
        {{ comment?.comment }}
      </div>

      <div *ngIf="comment?.isEditing" class="w-full">
        <mat-form-field appearance="outline" class="w-full">
          <textarea matInput [(ngModel)]="comment.comment"></textarea>
        </mat-form-field>
        <div class="flex justify-end gap-2 mt-2">
          <button
            class="text-[#E76B3F] bg-white px-3 py-1 border border-[#E76B3F] rounded hover:bg-[#e6dfdc]"
            (click)="comment.isEditing = false"
          >
            Cancel
          </button>
          <button
            class="bg-[#E76B3F] text-white px-4 py-1 rounded hover:bg-[#bf5630]"
            (click)="saveComment(comment)"
          >
            Save
          </button>
        </div>
      </div>
      <div class="flex justify-between items-center">
        <div
          *ngIf="
            !comment?.isEditing && comment?.created_by?.id !== user_info?.id
          "
        >
          <div
            class="flex items-center gap-1 cursor-pointer text-gray-500 hover:text-[#000000]"
            (click)="replyToComment(comment)"
          >
            <mat-icon style="color: #e76b3f; width: 20px; height: 20px"
              >reply</mat-icon
            >
            <button>Reply</button>
          </div>
        </div>

        <div class="flex justify-end gap-4 text-sm text-gray-500 mt-1 w-[100%]">
          <div
            (click)="editComment(comment)"
            *ngIf="
              comment?.created_by?.id === user_info?.id && !comment?.isEditing
            "
          >
            <div
              class="flex justify-start items-center gap-1 cursor-pointer hover:text-[#000000]"
            >
              <mat-icon style="color: #e76b3f; width: 20px; height: 20px"
                >edit</mat-icon
              >

              <button>Edit</button>
            </div>
          </div>
          <div
            (click)="deleteComment(comment?.id)"
            *ngIf="
              comment?.created_by?.id === user_info?.id && !comment?.isEditing
            "
          >
            <div
              class="flex justify-start items-center gap-1 cursor-pointer hover:text-red-600"
            >
              <mat-icon style="color: #e76b3f; width: 20px; height: 20px"
                >delete</mat-icon
              >

              <button>Delete</button>
            </div>
          </div>
        </div>
      </div>

      <!-- 💬 Reply Input -->
      <div
        *ngIf="comment.isReplying"
        class="mt-2 ml-4 border-l pl-4 border-gray-300"
      >
        <mat-form-field appearance="outline" class="w-full">
          <textarea
            matInput
            [(ngModel)]="replyContent"
            placeholder="Write a reply..."
            rows="2"
          ></textarea>
        </mat-form-field>
        <div class="flex justify-end gap-2 mt-2">
          <button
            class="text-[#E76B3F] bg-white px-3 py-1 border border-[#E76B3F] rounded hover:bg-[#e6dfdc]"
            (click)="comment.isReplying = false"
          >
            Cancel
          </button>
          <button
            class="bg-[#E76B3F] text-white px-4 py-1 rounded hover:bg-[#bf5630]"
            (click)="addReply(comment)"
          >
            Reply
          </button>
        </div>
      </div>

      <!-- 💬 Replies Display -->
      <div
        *ngIf="comment.replies?.length"
        class="mt-3 space-y-2 ml-4 border-l pl-4 border-gray-300"
      >
        <div *ngFor="let reply of comment?.replies" class="space-y-1">
          <div class="flex justify-between items-center">
            <div class="flex items-center gap-2">
              <img
                alt="icon"
                src="https://i.pravatar.cc/40?img={{ reply?.id }}"
                class="w-7 h-7 rounded-full"
              />
              <p class="font-semibold text-sm">
                {{
                  reply?.created_by?.username
                    ? reply?.created_by?.username
                    : (reply?.created_by?.name | titlecase)
                }}
              </p>
            </div>
            <p class="text-xs text-gray-500">
              {{ getTimeAgo(reply?.created_at) }}
            </p>
          </div>
          <div class="text-gray-700 text-sm">{{ reply?.comment }}</div>
        </div>
      </div>
    </div>

    <!-- Add New Comment -->
    <div class="bg-white border p-4 shadow-sm">
      <div class="flex items-start gap-2">
        <img
          alt="icon"
          src="https://i.pravatar.cc/40?u=you"
          class="w-8 h-8 rounded-full"
        />
        <div class="w-full">
          <mat-form-field appearance="outline" class="w-full">
            <textarea
              matInput
              [(ngModel)]="newComment"
              placeholder="Write a comment..."
              (keydown.enter)="addComment()"
              rows="3"
            ></textarea>
          </mat-form-field>
          <div class="flex justify-end mt-5">
            <button
              class="bg-[#E76B3F] text-white px-4 py-1 rounded hover:bg-[#bf5630]"
              (click)="addComment()"
            >
              Send
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
